<template>
  <div class="header-message">
    <el-popover
      v-model="popover"
      popper-class="header-message-popover"
      placement="bottom"
      width="250"
      trigger="click"
    >
      <div v-if="messageTotal > 0" class="message-banner">
        <h4>{{ $t('grid.others.latestNews') }}</h4>
        <ul>
          <li
            v-for="(item, index) in messageList"
            :key="index"
            @click="toSendMassage(item)"
          >
            <p>{{ item.sMsgTitle }}</p>
            <span>{{
              renderTime(item.sSendTime ? item.sSendTime : item.sCreateTime)
            }}</span>
          </li>
        </ul>
        <p class="view-all" @click="toSendMassage()">
          {{ $t('login.viewAllInformation') }}
        </p>
      </div>
      <div v-else class="no-message">{{ $t('grid.others.noData') }}</div>
      <template slot="reference">
        <div class="header-message-view flexCC">
          <cnd-icon name="cnd-remind" />
          <p v-if="messageTotal > 0" class="message-total">
            <span>{{ messageTotal_ }}</span>
          </p>
        </div>
      </template>
    </el-popover>
  </div>
</template>

<script>
export default {
  name: 'HeaderMessage',
  props: {
    // 消息数据
    messageList: {
      type: Array,
      default: () => []
    },
    // 消息数据
    messageTotal: {
      type: Number,
      default: 0
    },
    // 用户信息
    userInfo: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      popover: false
    }
  },
  computed: {
    messageTotal_() {
      return this.messageTotal <= 99 ? this.messageTotal : '99+'
    }
  },
  watch: {
    popover(nv, ov) {
      nv && this.$emit('setMessageList')
    }
  },
  methods: {
    toSendMassage(item = '') {
      this.popover = false
      this.$emit('toSendMassage', item)
    },
    renderTime(date) {
      if (!date) return ''
      const _date = new Date(date).toJSON()
      return new Date(+new Date(_date) + 8 * 3600 * 1000)
        .toISOString()
        .replace(/T/g, ' ')
        .replace(/\.[\d]{3}Z/, '')
    }
  }
}
</script>
